<template>
  <div>
    <a-row class="header">
      <a-col class="flex">
        <div class="login-content-wrapper logo-wrapper">
          <span class="logo-img">
            <img v-if="platform === 'sysu'" alt="中山大学" src="./images/zdLogo.jpg" />
            <img v-else alt="云采链" src="./images/logo.png" height="71" width="247" />
          </span>
          <a-divider
            type="vertical"
            style="height: 48px; margin: 0 29px; color: #d8d8d8"
          />
          <span class="logo-font">{{ title }}</span>
        </div>
        <span class="login-text">
          已有账号，
          <router-link :to="{ name: 'sysuLogin' }"
            >立即登录</router-link
          >
        </span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      default: '立即注册'
    }
  },
  data () {
    return {}
  },
  computed: {
    platform () {
      return this.$route.params.platform
    }
  }
}
</script>

<style lang="less" scoped>
@labelColor: #fff;
.flex {
  display: flex;
  justify-content: space-between;
  max-width: 1300px;
  margin: 0 auto;
}
.header {
  min-width: 1220px;
  .logo-wrapper {
    width: 90%;
    margin: 0 auto;
    line-height: 120px;
    background-color: @labelColor;
    height: 124px;
  }
  .logo-img > img {
    width: 200px;
  }
  .logo-font {
    font-size: 40px;
    color: #2c3e50;
    vertical-align: middle;
  }
  .login-text {
    vertical-align: bottom;
    line-height: 124px;
    white-space: nowrap;
    transform: translateY(20px);
  }
}
</style>
